import React from "react";
import { useNavigate } from "react-router-dom";
import classes from "./contact.module.css";

function Contact() {
  const navigate = useNavigate();
  return (
    <div className={classes.container}>
      <p
        onClick={() => {
          navigate("/profile", { replace: true });
        }}
      >
        <i class="fa-solid fa-arrow-left"></i>
      </p>
      <h1>Contact Us</h1>
      <div className={classes.social}>
        <a
          target="blank"
          href="https://instagram.com/dc_luxurious?igshid=YmMyMTA2M2Y="
          className={classes.socials}
        >
          <i className="fa-brands fa-instagram"></i>
          <h2>Instagram</h2>
          <div className={classes.greater}>
            <i className="fa-solid fa-greater-than"></i>
          </div>
        </a>
        <a
          target="blank"
          href="https://www.facebook.com/DCluxurious"
          className={classes.socials}
        >
          <i className="fa-brands fa-facebook"></i>
          <h2>Facebook</h2>
          <div className={classes.greater}>
            <i className="fa-solid fa-greater-than"></i>
          </div>
        </a>
        <a
          href="https://twitter.com/Dc_luxurious?t=Zm2nqFXZJUnkdrw-_x7B3w&s=09"
          target="blank"
          className={classes.socials}
        >
          <i class="fa-brands fa-twitter"></i>
          <h2>Twitter</h2>
          <div className={classes.greater}>
            <i className="fa-solid fa-greater-than"></i>
          </div>
        </a>
        <a
          href="https://wa.me/2348144278102"
          target="blank"
          className={classes.socials}
        >
          <i class="fa-brands fa-whatsapp"></i>
          <h2>WhatsApp</h2>
          <div className={classes.greater}>
            <i className="fa-solid fa-greater-than"></i>
          </div>
        </a>
        <a href="mailto: dcluxurious@gmail.com" className={classes.socials}>
          <i className="fa-solid fa-envelopes-bulk"></i>
          <h2>Email</h2>
          <div className={classes.greater}>
            <i className="fa-solid fa-greater-than"></i>
          </div>
        </a>
      </div>
    </div>
  );
}

export default Contact;
